import { ReactNode } from "react";
import { CloseButton, Group, Paper, Text, ThemeIcon, Title } from "@mantine/core";

/** TextInput props for a ✕ that clears a search box, shown only while it has text. */
export const ctcClearable = (value: string, onClear: () => void) => ({
    rightSection: value ? <CloseButton size="sm" aria-label="Clear search" onClick={onClear} /> : null,
    rightSectionPointerEvents: "all" as const,
});

/**
 * The white box every CTC list screen sits in (Watch list, Purchase orders, Transactions, Back office), with its
 * filters, table and pager. Optional header (icon + title + one line) for screens the tab bar doesn't name. Fades in.
 */
export function CtcPanel({ icon, title, description, children }: { icon?: ReactNode; title?: ReactNode; description?: ReactNode; children: ReactNode }) {
    return (
        <Paper withBorder radius="md" p="md" className="ctc-panel" style={{ minWidth: 0, overflowX: "auto" }}>
            {/* Header only where the screen isn't already named by the tab bar (Back office sections) */}
            {title && (
                <Group gap="sm" mb={description ? 4 : "md"} wrap="nowrap">
                    {icon && <ThemeIcon variant="light" size="lg" radius="md">{icon}</ThemeIcon>}
                    <Title order={4}>{title}</Title>
                </Group>
            )}
            {title && description && <Text size="sm" c="dimmed" mb="md">{description}</Text>}
            {children}
            <style>{`
                .ctc-panel { animation: ctc-panel-in 220ms ease; }
                @keyframes ctc-panel-in { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
            `}</style>
        </Paper>
    );
}
